import React from 'react';

import { HStack } from '@rtkwlf/fenrir-react';

import { NavigationItem } from './navigation-item/navigation-item';
import type { MenuItem } from './navigation.constants';

export type NavigationViewProps = {
  items: MenuItem[];
};

export const Navigation: React.FC<NavigationViewProps> = ({ items }) => (
  <HStack>
    {items.map((item) => (
      <NavigationItem key={item.to} item={item} />
    ))}
  </HStack>
);
